import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import useRequireAuth from "../../../utils/useRequireAuth";
import { ReactComponent as CloseModalImg } from "../../../assets/images/closeModalImg.svg";
import { useLazyFetchPersonInTableQuery } from "../../../utils/customer/customerTable";
import { Dialog } from "@mui/material";
import PermissionUsers from "../../GlobalFeature/Fields/PermissionUsers";
import CreatePortalHOC from "../../GlobalFeature/Fields/CreatePortalHOC";

const ShareDocModal = ({ open, close, handleSubmitData }) => {
  const dispatch = useDispatch();

  const { id } = useParams();
  const customerId = parseInt(id);
  const companyLocalData = localStorage.getItem("company_data");
  const companyId = JSON.parse(localStorage.getItem("company_data")).company_id;
  const parsedCompanyData = JSON.parse(companyLocalData);

  const [personsIntable, setPersonsInTable] = useState();
  const [showPermissionList, setShowPermisionList] = useState(false);
  const [authorizedUsers, setAuthorizedUsers] = useState([]);
  const [inputUser, setInputUser] = useState([]);
  const [isOpenHover, setIsOpenHover] = useState(false);

  const { token } = useRequireAuth();
  console.log("fetchPerson token", token);

  const divRef = useRef();
  const userLisrRef = useRef();

  const getCreatePortalPosition = (ele, yPos, xPos, yShift = 0, xshift = 0) => {
    if (ele.current) {
      const rect = ele.current.getBoundingClientRect(); // Get the bounding rectangle
      const posY = rect[yPos];
      const posX = rect[xPos];
      return {
        top: posY + window.scrollY + yShift,
        left: posX + window.scrollX + xshift,
        borderRadius: "5",
      };
    }
  };

  const [fetchPersonInTable, { data: personTableData, isFetching }] = useLazyFetchPersonInTableQuery();
  // const [updateCustomerDelegation, { isLoading: delegationLoading }] = useUpdateCustomerDelegationMutation();
  // const [searchTerm, setSearchTerm] = useState("");

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token, data: data, companyId: companyId });
  };
  useEffect(() => {
    console.log("fetchPerson effect token", token);
    if (token) fetchPersonData("");
  }, [token]);

  const handleSubmit = async (event) => {};

  const handleSelectPerson = async (event, value, deleteBool) => {
    event.stopPropagation();
    setAuthorizedUsers((prev) => [value, ...prev]);
    setShowPermisionList(false);
    setInputUser(value.email);
    // const payload = {
    //   customer_id: ItemComplete?.customer_id?.id,
    //   company_id: ItemComplete?.company_id?.value,
    //   user_id: value?.id,
    //   email: value?.email,
    //   org_id: org_id,
    //   multiData: multiDataCheck,
    //   owner: 0,
    // };

    // try {
    //   const updateDelegationResponse = await updateCustomerDelegation({
    //     token: token?.token,
    //     data: payload,
    //     isDelete: deleteBool,
    //   });
    //   if (updateDelegationResponse?.data?.status == true) {
    //     setAlert({
    //       open: true,
    //       message: "Delegation Updated Successfully",
    //       type: "success",
    //     });
    //     refetchCustomerData();
    //   } else {
    //     setAlert({
    //       open: true,
    //       message: "Error updating data!",
    //       type: "danger",
    //     });
    //     refetchCustomerData();
    //   }
    // } catch (error) {
    //   console.error("Error updating data:", error);
    //   // setAlert({
    //   //   open: true,
    //   //   message: "Error updating data!",
    //   //   type: "danger",
    //   // });

    //   // setLoading(false);
    // } finally {
    //   // setLoading(false);
    // }
  };

  const handleOpen = (event) => {
    setIsOpenHover(true);
  };

  const handleClose = () => {
    // setDropdownCoord(null);
    setIsOpenHover(false);
  };

  const handleDeletePerson = (person) => {
    const filterPersons = authorizedUsers.filter((per) => per.id !== person.id);

    console.log("debug01", person, filterPersons);

    setAuthorizedUsers(filterPersons);
  };

  useEffect(() => {}, [personTableData]);

  return (
    <Dialog open={open} fullWidth>
      <div className="flex items-center justify-between p-1 pl-3 pr-4 border-BECBD3 rounded-t">
        <div className="px-2">
          <br className="mb-2" />
        </div>
        <br />
        <h3 className="text-16 font-500 text-[#434852]">Share File</h3>
        <button
          onClick={close}
          type="button"
          className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
          data-modal-hide="assets-modal"
        >
          {/* <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg> */}
          <CloseModalImg className="w-3 h-3" />
          <span className="sr-only">Close modal</span>
        </button>
      </div>
      <form onSubmit={handleSubmit} className="w-full lg:max-h-[70vh] overflow-x-hidden no-scrollbar">
        <div className="basis-5/5 mb-3 px-6  ">
          <label htmlFor="Designation" className="block mb-2 text-434852 text-14 font-400 border-t pt-3 ">
            Name, Group or Email
            {/* {errors && <span className="text-red-700"> {errors.doc_type}</span>} */}
          </label>

          <div ref={divRef} className="border-[#B6BBBF] border bg-[#F8F8F8] flex">
            <input
              type="text"
              placeholder="Type a name or email address"
              className="w-[100%] h-[38px] border-none rounded-md text-[12px] font-[400] text-[#848687] focus:ring-0"
              // focus:ring-offset-0
              // focus:ring-transparent
              onFocus={() => setShowPermisionList(true)}
              value={inputUser}
              // onChange={handleCheck}
            />
            <select
              className={`form-select flex-initial max-w-fit rounded bg-[#F3F5F7] border-none focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full px-2.5 py-1 h-8 leading-normal`}
              id={`doc_type`}
              name="doc_type"
              // value={formData.doc_type}
              // onChange={handleFieldChange}
            >
              {["Can Edit", "Can View"].map((permission) => (
                <option key={permission} value={permission}>
                  {permission}
                </option>
              ))}
            </select>
            <PermissionUsers
              searchBoxDisabled
              FieldType={"text"}
              showPermissionList={showPermissionList}
              setShowPermisionList={setShowPermisionList}
              handleSelectPerson={handleSelectPerson}
              handleDeletePerson={handleDeletePerson}
              authorisedUsers={authorizedUsers}
              // FieldValue={parsedValue}
              // FieldChange={CellChange}
              setDataInputRow={() => console.log()}
              // UpdateTableField={UpdateField}
              // Item={Item[Header?.key]}
              clientCoord={getCreatePortalPosition(divRef, "bottom", "left")}
              // ItemComplete={Item}
              // refetchCustomerData={refetchCustomerData}
              // multiData={multiData}
            />
          </div>
          {/* {formErrors.doc_type && <span className="text-red-500 text-xs">Cannot be left blank.</span>} */}
        </div>

        <div className="p-3 md:px-6">
          <label htmlFor="chart_of_accounts_id" className="block mb-2 text-sm text-434852">
            Add A Message
          </label>
          <textarea
            name="descriptions"
            // onChange={handleFieldChange}
            placeholder="Type Something..."
            className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full h-24 resize-none"
          />
        </div>
        <div className="flex justify-between item-center text-md w-full">
          <div className="px-6 pb-3 space-x-1 flex items-end">
            {Array.isArray(authorizedUsers) &&
              authorizedUsers
                ?.filter((assigned, index) => index < 2)
                .map((eachInput, index) => {
                  const initials = eachInput.name
                    .split(" ")
                    .filter((word) => word.length > 0)
                    .map((word) => word.charAt(0).toUpperCase())
                    .slice(0, 2)
                    .join("");

                  return (
                    <div key={index} className="relative">
                      <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300  p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                        {initials}
                      </div>
                    </div>
                  );
                })}
            {authorizedUsers?.length > 2 && (
              <div className="">
                <div className="bg-gray-200 text-gray-500 text-12 font-600 border-gray-300   w-7 h-5 flex items-center justify-center rounded-full border-[1px]">
                  + {authorizedUsers?.length - 3}
                </div>
              </div>
            )}
            <div onMouseOver={handleOpen} onMouseLeave={handleClose}>
              <button
                type="button"
                id="threedot"
                className="threedot text-2541558A hover:text-254155"
                ref={userLisrRef}
              >
                <i className=" bi bi-three-dots text-14"></i>
              </button>
              {isOpenHover && (
                <CreatePortalHOC
                  isOpen={isOpenHover}
                  onClose={handleClose}
                  position={getCreatePortalPosition(userLisrRef, "top", "right", 0, 10)}
                  verticalDist={8}
                >
                  <div className="w-fit bg-white p-2">
                    {
                      <ul>
                        {authorizedUsers &&
                          authorizedUsers.map((user) => {
                            return (
                              <li className="p-2 m-2 flex justify-between text-[#2999BC]">
                                <span className="flex mr-2">
                                  <span className="bg-gray-200 mr-2 text-gray-500 text-12 font-600 border-gray-300  p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                    {user.name[0]}
                                  </span>
                                  {user.name}
                                </span>
                                <span className="text-[#BFC3C7]">X</span>
                              </li>
                            );
                          })}
                      </ul>
                    }
                  </div>
                </CreatePortalHOC>
              )}
            </div>
          </div>

          <div className="px-6 pb-3">
            <button
              onClick={close}
              type="button"
              className="w-28 text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1 text-center rounded-[5px]"
            >
              CANCEL
            </button>
            <button
              type="submit"
              className="w-28 text-white bg-1D4469 hover:bg-20486F save-btn font-semibold border border-gray-200 py-1 px-5 ms-3 rounded-[5px]"
              // onClick={}
            >
              SAVE
            </button>
          </div>
        </div>
      </form>
    </Dialog>
  );
};

export default ShareDocModal;
